import styled from 'styled-components';
import { ASSETS } from '../../../../../../../assets';

export const WidgetIcon = styled(ASSETS.SCISSORS)`
  width: 13.8px;
  height: 16px;
`;
